import styles from "./PublicationItem.module.scss";
import { Button, Tag, Tooltip, Typography } from "antd";
import { numberRegex } from "Explore/Utils/numberRegex";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import openalexLogo from "Explore/Assets/openalex-logo.png";
import { IconButton } from "@mui/material";

const PublicationItem = ({ data }) => {
  return (
    <div className={styles["publication"]}>
      <div className={styles["title"]}>
        <span
          className={`${styles["paper-title"]} ${!!data.doi ? styles["clickable"] : ""
            }`}
        >
          <a href={data.doi} target="_blank">
            {data.title}.
          </a>
        </span>{" "}
        <span className={styles["venue"]}>
          <i>{data.venue} </i>
        </span>
        <span>{data.year > 0 ? `(${data.year})` : ""}</span>
      </div>
      <div className={styles["coauthors"]}>
        <p>
          {data.coauthors.map((item, index) => {
            return <span key={index}>{item.name}</span>;
          })}
        </p>
      </div>
      <div className={styles["tags"]}>
        {data.keywords.map((item, index) => {
          return (
            <Tag key={index} color="blue">
              {item.id}
            </Tag>
          );
        })}
      </div>
      <div className={styles["action"]}>
        {false && (
          <Button
            style={{
              backgroundColor: "white",
              border: "none",
              boxShadow: "none",
              color: "#b45f06",
              borderRadius: 10,
              height: 25,
              paddingLeft: 0,
              textAlign: "left",
              textTransform: "none",
              cursor: "initial",
            }}
          >
            <FormatQuoteIcon />
            <Typography align={"left"} style={{ fontSize: 12 }}>
              {numberRegex(parseFloat(data["citation_count"]))}
            </Typography>
          </Button>
        )}
        {data?.openalex_id && (
          <Tooltip title="Open in OpenAlex">
            <a
              target="_blank"
              href={data.openalex_id}
              className={styles["openalex-link"]}
            >
              <IconButton>
                <img src={openalexLogo} width={20} height={20} />
              </IconButton>
            </a>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default PublicationItem;
